import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@mui/material';

import { useStyles } from './styles';
import { useMytaverse } from '@providers/MytaverseProvider';

const LegalNotes = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { appSettings } = useMytaverse();

  return (
    <Typography sx={classes.text}>
      {translate('legalNotes.preFix')}{' '}
      <Link
        href={appSettings?.termsOfServiceUrl}
        target="_blank"
        sx={classes.link}
      >
        {translate('legalNotes.terms')}
      </Link>{' '}
      {translate('legalNotes.and')}{' '}
      <Link
        href={appSettings?.privacyPolicyUrl}
        target="_blank"
        sx={classes.link}
      >
        {translate('legalNotes.privacy')}
      </Link>
    </Typography>
  );
};

export default LegalNotes;
